import React, { useEffect, useState } from 'react';
import s from './HotCard.scss';
import { useEffectAsync, useWindowModel } from '../../../hooks';
import { shortLargeInt, sleep } from '../../../utils';
import { useArticlePvAPI, useFeedApi } from '../../../hooks/APIs';
import { domDidChange } from '../../../utils/spmHelper';
import { LinkWrapper } from '../../../components/BaseComp';
import { FeedInstance } from '../../../models/feed';
import { WindowModelType } from '../../../models';

interface Props {
    title: string,
    reqId: number,
    size: number
}

interface DisplayHotArticle extends FeedInstance {
    pv: number,
}

const slices: {
    [key in WindowModelType]: number
} = {
    'phone': 6,
    'pad': 6,
    'mini': 9,
    'normal': 9,
};

export const HotCard = (props: Props) => {
    const { title, reqId, size } = props;
    const [articles] = useFeedApi(reqId, size);
    const [displayArticle, setDisplayArticle] = useState<DisplayHotArticle[]>([]);
    const [pvs] = useArticlePvAPI(articles, [articles]);
    const windowModel = useWindowModel();
    // TODO: Move this into `/../../../hooks`, and use config to determin witch api we use
    useEffect(() => {
        const arts: DisplayHotArticle[] = [];
        if (articles.length && articles.length === Object.keys(pvs).length) {
            arts.push(...articles.map(art => ({
                ...art,
                pv: pvs[`${art.id}`],
            })));
        }
        setDisplayArticle(arts.slice(0, slices[windowModel]));
    }, [articles, pvs, windowModel]);
    useEffectAsync(async () => {
        await sleep(100);
        domDidChange('top-hotarticles');
    }, [displayArticle]);

    return (
        <div className={s.cardContainer}>
            <h3 className={s.title}>{title}</h3>
            <ul data-spm="top-hotarticles">
                {
                    displayArticle.map((a, index) =>
                        <div className={s.item} key={index} data-spm-type="resource">
                            <LinkWrapper
                                data-spm-type="content"
                                className={s.feedTitle}
                                href={a.url ? a.url : `/a/${a.id}_${a.authorId}`}>
                                {a.title}
                            </LinkWrapper>
                            <LinkWrapper
                                href={a.url ? a.url : `/a/${a.id}_${a.authorId}`}
                                className={s.count}>
                                <p className={s.counts}>{shortLargeInt(a.pv)}</p>
                                <p className={s.countLabel}>阅读</p>
                            </LinkWrapper>
                        </div>,
                    )
                }
            </ul>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/HomeTop/HotCard/HotCard.pv.tsx